import { createSelector } from '@reduxjs/toolkit';

import { RootState } from 'types';
import { initialState } from '.';

const selectSlice = (state: RootState) => state.mountingPlate || initialState;

export const selectMountingPlate = createSelector(
  [selectSlice],
  state => state.data,
);
